// extracted by mini-css-extract-plugin
export default {"projectEconomyWrappers":"ProjectEconomyWrappers_projectEconomyWrappers__JvjYb","modalContentContainer":"ProjectEconomyWrappers_modalContentContainer__sQzgp"};